/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Vector3 } from 'three';
import { BasePanNavigator } from './BasePanNavigator';
import { NavUtils } from './NavUtils';
const INTERNAL_SPEED_FACTOR = 0.0025;
/**
 * Navigator fragment for free camera look around
 */
export class LookAroundNavigator extends BasePanNavigator {
    constructor(cam, el, speed = 1) {
        super(cam, el, speed);
        this.up = new Vector3(0, 1, 0);
        this._calcLookAt = NavUtils.calcLookAt(() => this._cam);
        this._calcCameraRight = NavUtils.calcCameraRight(() => this._cam);
    }
    /*get up() {
      return NavUtils.getSceneUp(this._cam);
    }*/
    pan(event) {
        const { movementX, movementY } = event.detail;
        const speed = INTERNAL_SPEED_FACTOR * this.speed;
        const angleUp = movementX * speed;
        const angleRight = -movementY * speed;
        const camera = this._cam;
        const rotation = NavUtils.rotateCameraAround(camera.position, this._calcLookAt(), this._calcCameraRight(), this.up, angleUp, angleRight);
        camera.matrix.copy(rotation.matrix);
        camera.quaternion.setFromRotationMatrix(rotation.matrix);
        camera.up.copy(rotation.up);
    }
}
//# sourceMappingURL=LookAroundNavigator.js.map